import { COMMON_TYPE_REDUCER } from '../../constants/common'

const commonReducer = (state = {}, action: any) => {
    switch (action.type) {
        case COMMON_TYPE_REDUCER.SHOW_LOADING:
            return {
                ...state,
                isShowLoading: action.isShowLoading,
            }
        case COMMON_TYPE_REDUCER.SHOW_LOADING_GIU_CHO:
            return {
                ...state,
                showLoadingComBo: action.showLoadingComBo,
            }
        case COMMON_TYPE_REDUCER.TOGGLE_SIDE_BAR_MOBILE:
            return { ...state, isOpenSideBar: action.payload }
        case COMMON_TYPE_REDUCER.TOGGLE_REVIEW_INFO:
            return { ...state, isOpenReviewInfo: action.payload }
        default:
            return { ...state }
    }
}

export default commonReducer
